import React, {Component} from "react";
import {withRouter} from 'react-router-dom';
import CommToolContext from "./comm_tool_context";

const dashboard = {
    'A': 'active',
    'U': 'upcoming',
    'D': 'development',
    'R': 'release',
    'C': 'closed',
    'N': 'checklist_na',
}

class CommToolProvider extends Component {
    state = {
        step: 9,
        activeDashboardTab: "U",
        launchDashboard: true,
        bpid: 99,
        workOrder: 999,
        checkListOwner: "",
        releaseStep: "1",
        releaseTab: false,
        activeProject: {},
        activeReleaseTab: "1",
        activeActiveTab: "1",
        userProfile: null,
        projectTab: null,
        refreshNotifications: false,
        refreshMemberNotifications: false
    };

    render() {
        const {history} = this.props;

        return (
            <CommToolContext.Provider
                value={{
                    state: this.state,
                    setStep: step =>
                        this.setState({
                            step: step
                        }),
                    setUserProfile: profile =>
                        this.setState({
                            userProfile: profile
                        }),
                    setProjectTab: tab =>
                        this.setState({
                            projectTab: tab
                        }),
                    setLaunchDashboard: launchDashboard =>
                        this.setState({
                            launchDashboard: launchDashboard
                        }),
                    setActiveProject: project =>
                        this.setState({
                            activeProject: project
                        }),
                    setActiveDashboardTab: activeDashboardTab => {
                        const page = dashboard[activeDashboardTab];
                        history.push(`/dashboard/${page}`);
                    },
                    setActiveReleaseTab: activeReleaseTab =>
                        this.setState({
                            activeReleaseTab: activeReleaseTab
                        }),
                    setActiveActiveTab: activeActiveTab =>
                        this.setState({
                            activeActiveTab: activeActiveTab
                        }),
                    setReleaseStep: releaseStep =>
                        this.setState({
                            releaseStep: releaseStep
                        }),
                    setReleaseTab: releaseTab =>
                        this.setState({
                            releaseTab: releaseTab
                        }),
                    setCheckListOwner: checkListOwner =>
                        this.setState({
                            checkListOwner: checkListOwner
                        }),
                    setAssets: assets =>
                        this.setState({
                            assets: assets
                        }),
                    setRefreshNotifications: isRefresh =>
                        this.setState({
                            refreshNotifications: isRefresh
                        }),
                    setRefreshMemberNotifications: isRefresh =>
                        this.setState({
                            refreshMemberNotifications: isRefresh
                        })
                }}
            >
                {this.props.children}
            </CommToolContext.Provider>
        );
    }
}

export default withRouter(CommToolProvider);
